import PropTypes from 'prop-types'
import { Handle, Position, useUpdateNodeInternals } from '@xyflow/react'
import { useEffect, useRef, useState, useContext } from 'react'
import { isValidConnection } from '@/utils/genericHelper'
// project import
import { FlowContext } from '@/store/context/ReactFlowContext'

// Custom Tooltip
const Tooltip = ({ title, children }) => {
    return (
        <div className="relative">
            <div className='absolute -right-4 top-1/2 transform -translate-y-1/2'>
            {children}
            <div className="p-2 text-right">{title}</div>
            </div>
        </div>
    )
}

// ===========================|| NodeOutputControlHandler ||=========================== //

const NodeOutputControlHandler = ({ outputControl, data }) => {
    const ref = useRef<HTMLDivElement | null>(null)
    const updateNodeInternals = useUpdateNodeInternals()
    const [position, setPosition] = useState<number>(0)
    const [dropdownValue, setDropdownValue] = useState<any>(null)
    const { reactFlowInstance } = useContext(FlowContext)

    useEffect(() => {
        if (ref.current) {
            setPosition((ref.current.offsetTop + ref.current.clientHeight/2))
        }
    }, [ref, updateNodeInternals])

    useEffect(() => {
        updateNodeInternals(data.id)
    }, [position, updateNodeInternals])

    useEffect(() => {
        if (dropdownValue) {
            updateNodeInternals(data.id)
        }
    }, [dropdownValue, updateNodeInternals])


   

    return (
        <div ref={ref} className="flex flex-col">
           
                <Handle
                    type="source"
                    position={Position.Right}
                    id={outputControl.id}
                    className="h-3 w-3 bg-red-500 rounded-full"
                    style={{ height: "10px",width: "10px", backgroundColor: "red", borderRadius: "100%" , top: position  }}
                    // isValidConnection={(connection) => isValidConnection(connection, reactFlowInstance)}
                />
            <div className="p-2 text-right">
                <p>{outputControl.name}</p>
            </div>
        </div>
    )
}

NodeOutputControlHandler.propTypes = {
    outputControl: PropTypes.object,
    data: PropTypes.object
}

export default NodeOutputControlHandler
